import Util from "./Util.js";
import { gsap } from "./Util.js";

class Filter extends Util {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.filterForm = document.getElementById("product-filters");
    if (!this.filterForm) return;
    this.isCollectionItem = document.querySelector("#collection-item");
    // ページタイプを識別
    this.isCaseStudyPage = document.querySelector("#case-study") !== null;
    this.isMainCollectionPage = document.querySelector("#collection-item") !== null;
    this.isWoodMaterialPage = document.querySelector("#wood-material") !== null;
    this.sortTab();
    this.filterFunc();

    if (this.isWoodMaterialPage) {
      const btn = document.querySelectorAll(".btn-collection-select");
      for (let i = 0; i < btn.length; i++) {
        btn[i].addEventListener("click", () => {
          document.querySelector(".collection-sort-area").classList.add("is-open");
          gsap.set("body", {
            overflow: "hidden",
          });
        });
      }

      document.querySelector(".collection-sort-area .btn-close").addEventListener("click", () => {
        document.querySelector(".collection-sort-area").classList.remove("is-open");
        gsap.set("body", {
          overflow: "auto",
        });
      });
      document.querySelector(".collection-sort-area .bg").addEventListener("click", () => {
        document.querySelector(".collection-sort-area").classList.remove("is-open");
        gsap.set("body", {
          overflow: "auto",
        });
      });
    }
  }

  sortTab() {
    if (!document.querySelector(".sort-by")) return;

    const sortBy = document.querySelector(".sort-by");
    const target = sortBy.querySelector(".txt");

    target.addEventListener("click", () => {
      sortBy.classList.toggle("is-open");
    });
  }

  filterFunc() {
    this.currentSortDiv = document.querySelector(".current-sort");
    this.applyFiltersButton = document.getElementById("apply-filters-btn");
    this.applyFiltersButtonText = this.applyFiltersButton ? this.applyFiltersButton.querySelector(".btn-text") : null;
    this.sortByButtonsContainer = document.querySelector(".sort-by-buttons");
    this.productsGridElement = document.querySelector(".products-grid");
    this.productCountElement = document.querySelector(".product-count p");
    this.productCountBadgeElement = document.querySelector(".product-count b");

    this.btnOpen = document.querySelector(".btn-filter.open");
    this.filtersArea = document.querySelector(".filters-area");
    this.bgClose = document.querySelector(".bg-close");

    // --- Configuration ---
    this.DEBOUNCE_DELAY = 500;

    // --- State ---
    this.debounceTimer = null; // 初期化

    // --- Expose to Global Shopify Object ---
    window.Shopify = window.Shopify || {};
    // bind(this) を使って、クラスメソッド内の this が Filter インスタンスを指すようにする
    window.Shopify.handleSortChange = this.handleSortChange.bind(this);
    window.Shopify.clearFilters = this.clearAllFilters.bind(this);

    // --- Initial Load ---
    if (this.isCollectionItem || this.isWoodMaterialPage) {
      this.spEvent();
    }

    this.initializeFiltersFromURL();
    this.bindEventListeners();
    this.updateProductCountOnButton(); // 初期表示の件数更新
    this.updateCurrentSortDisplay(); // 初期表示のソート状態表示
    this.checkAndToggleApplyButtonVisibility();
  }

  spEvent() {
    this.btnOpen.addEventListener("click", () => {
      this.filtersArea.classList.toggle("is-open");
    });
    this.bgClose.addEventListener("click", () => {
      this.filtersArea.classList.toggle("is-open");
    });
  }

  // --- Utility Functions ---
  updateURL(params) {
    const newRelativePathQuery = window.location.pathname + "?" + params.toString() + window.location.hash;
    window.history.replaceState({ path: newRelativePathQuery }, "", newRelativePathQuery);
  }

  async fetchAndParseHTML(url, options = {}) {
    const response = await fetch(url, {
      headers: { "X-Requested-With": "XMLHttpRequest", ...options.headers },
      ...options,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const htmlString = await response.text();
    const parser = new DOMParser();
    return parser.parseFromString(htmlString, "text/html");
  }

  updateProductDisplay(doc) {
    const newProductsGrid = doc.querySelector(".products-grid");
    if (newProductsGrid && this.productsGridElement) {
      this.productsGridElement.innerHTML = newProductsGrid.innerHTML;
    } else if (this.productsGridElement) {
      this.productsGridElement.innerHTML = "<p>該当する商品が見つかりませんでした。</p>";
    }

    const newProductCountText = doc.querySelector(".product-count p"); // section.product_count から p タグを取得
    if (newProductCountText && this.productCountElement) {
      this.productCountElement.textContent = newProductCountText.textContent;
    }

    const newProductCountBadge = doc.querySelector(".product-count b"); // 同様に b タグを取得
    if (newProductCountBadge && this.productCountBadgeElement) {
      this.productCountBadgeElement.textContent = newProductCountBadge.textContent;
    }

    window.MOUSE_INSTANCE.events();
    window.APP_INSTANCE.fadeOut();
    this.showContents();
  }

  setButtonLoadingState(button, buttonTextEl, isLoading, loadingText = "処理中...", originalText = "条件を絞り込む") {
    if (!button || !buttonTextEl) return;
    button.disabled = isLoading;
    button.classList.toggle("loading", isLoading);
    buttonTextEl.textContent = isLoading ? loadingText : originalText;
  }

  getProductCountFromDoc(doc) {
    const grid = doc.querySelector(".products-grid");
    if (!grid) return 0;

    // ケーススタディページでは .case セレクターを使用
    if (this.isCaseStudyPage) {
      return grid.querySelectorAll(".case").length;
    }
    // メインコレクションページでは .item セレクターを使用（既存の動作）
    return grid.querySelectorAll(".item").length;
  }

  // --- Sort Functions ---
  getActiveSortValue() {
    const activeButton = this.sortByButtonsContainer ? this.sortByButtonsContainer.querySelector(".sort-button.active") : null;
    return activeButton ? activeButton.dataset.sortBy : null;
  }

  updateSortButtonsUI(activeSortValue) {
    if (!this.sortByButtonsContainer) return;
    const buttons = this.sortByButtonsContainer.querySelectorAll(".sort-button");
    buttons.forEach((button) => {
      button.classList.toggle("active", button.dataset.sortBy === activeSortValue);
    });
    const sortByContainer = document.querySelector(".sort-by");
    if (sortByContainer) sortByContainer.classList.remove("is-open");
    const sortBySelect = document.getElementById("sort-by-select");
    if (sortBySelect) sortBySelect.value = activeSortValue || "";
  }

  updateCurrentSortDisplay() {
    if (!this.currentSortDiv || !this.sortByButtonsContainer) return;

    const activeButton = this.sortByButtonsContainer.querySelector(".sort-button.active");
    if (activeButton) {
      this.currentSortDiv.textContent = activeButton.textContent.trim();
      return;
    }

    // アクティブなボタンがない場合、デフォルトまたは最初のボタンを試みる
    let defaultSortValue = '{{ collection.default_sort_by | default: "" }}';
    defaultSortValue = defaultSortValue.startsWith("{{") ? "" : defaultSortValue; // Liquidが評価されなかった場合のフォールバック
    let buttonToDisplay = null;

    if (defaultSortValue) {
      // 空文字でなければ実行
      buttonToDisplay = this.sortByButtonsContainer.querySelector(`.sort-button[data-sort-by="${defaultSortValue}"]`);
    }

    if (!buttonToDisplay && this.sortByButtonsContainer.firstElementChild && this.sortByButtonsContainer.firstElementChild.classList.contains("sort-button")) {
      buttonToDisplay = this.sortByButtonsContainer.firstElementChild;
    }

    if (buttonToDisplay) {
      // 他にアクティブなボタンがなければ、このボタンをアクティブにする
      if (!this.sortByButtonsContainer.querySelector(".sort-button.active")) {
        buttonToDisplay.classList.add("active"); // UI更新
        const sortBySelect = document.getElementById("sort-by-select");
        if (sortBySelect) sortBySelect.value = buttonToDisplay.dataset.sortBy;
      }
      this.currentSortDiv.textContent = buttonToDisplay.textContent.trim();
    } else {
      this.currentSortDiv.textContent = "指定なし";
    }
  }

  // --- Filter Count Update ---
  async updateProductCountOnButton() {
    if (!this.applyFiltersButton || !this.applyFiltersButtonText) return;

    const formData = new FormData(this.filterForm);
    const params = new URLSearchParams();

    formData
      .getAll("constraint")
      .filter((val) => val) // 空の値をフィルタリング
      .forEach((val, index, arr) => {
        if (index === 0) params.set("constraint", val);
        else params.append("constraint", val);
      });
    if (params.has("constraint")) {
      // 複数のconstraintをカンマ区切りに
      const constraints = params.getAll("constraint");
      params.delete("constraint");
      params.set("constraint", constraints.join(","));
    }

    // ケーススタディページでは価格フィルターを処理しない
    if (!this.isCaseStudyPage) {
      const selectedPriceRange = formData.get("price_range");
      if (selectedPriceRange && selectedPriceRange !== "all") {
        const [min, max] = selectedPriceRange.split("-");
        if (min) params.set("filter.v.price.gte", min);
        if (max) params.set("filter.v.price.lte", max);
      }
    }

    const currentSortBy = this.getActiveSortValue();
    if (currentSortBy) {
      params.set("sort_by", currentSortBy);
    }

    const fetchUrl = `${window.location.pathname}?${params.toString()}`;

    try {
      const doc = await this.fetchAndParseHTML(fetchUrl);
      const productCount = this.getProductCountFromDoc(doc);
      this.applyFiltersButtonText.textContent = `条件を絞り込む (${productCount}件)`;
    } catch (error) {
      console.error("商品数の取得エラー:", error);
      this.applyFiltersButtonText.textContent = "条件を絞り込む (エラー)";
    }
    this.checkAndToggleApplyButtonVisibility();
    // finallyブロックは、この関数では特にローディング状態を戻す必要がないため不要
  }

  handleFilterInputChange() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(this.updateProductCountOnButton.bind(this), this.DEBOUNCE_DELAY);
  }

  // --- Main Filter/Sort Actions ---
  async applyFilters() {
    if (!this.applyFiltersButton || !this.applyFiltersButtonText) return;

    this.setButtonLoadingState(this.applyFiltersButton, this.applyFiltersButtonText, true, "処理中...");

    const formData = new FormData(this.filterForm);
    const params = new URLSearchParams(window.location.search); // 既存のパラメータを引き継ぐ

    // constraintパラメータの処理
    const constraintValues = formData.getAll("constraint").filter((val) => val);
    if (constraintValues.length > 0) {
      params.set("constraint", constraintValues.join(","));
    } else {
      params.delete("constraint");
    }

    // 価格パラメータの処理（ケーススタディページでは処理しない）
    if (!this.isCaseStudyPage) {
      params.delete("filter.v.price.gte");
      params.delete("filter.v.price.lte");
      const selectedPriceRange = formData.get("price_range");
      if (selectedPriceRange && selectedPriceRange !== "all") {
        const [min, max] = selectedPriceRange.split("-");
        if (min) params.set("filter.v.price.gte", min);
        if (max) params.set("filter.v.price.lte", max);
      }
    }

    // ソートパラメータの処理
    const sortBy = this.getActiveSortValue();
    if (sortBy) {
      params.set("sort_by", sortBy);
    } else {
      params.delete("sort_by"); // 明示的に削除した方が安全な場合
    }

    const fetchUrl = `${window.location.pathname}?${params.toString()}`;

    try {
      this.hideContents();
      const doc = await this.fetchAndParseHTML(fetchUrl);
      this.updateProductDisplay(doc);
      this.updateURL(params);
      this.updateCurrentSortDisplay(); // ソート表示も更新
      const productCount = this.getProductCountFromDoc(doc);
      // ボタンのテキストと状態をここで最終的に設定
      this.setButtonLoadingState(this.applyFiltersButton, this.applyFiltersButtonText, false, "処理中...", `条件を絞り込む (${productCount}件)`);
    } catch (error) {
      console.error("フィルター適用エラー:", error);
      this.setButtonLoadingState(this.applyFiltersButton, this.applyFiltersButtonText, false, "処理中...", "条件を絞り込む (エラー)");
    }
    this.checkAndToggleApplyButtonVisibility();
    // finally ブロックでの updateProductCountOnButton 呼び出しは削除 (二重 fetch となるため)
  }

  async handleSortChange(sortValue) {
    this.hideContents();

    const params = new URLSearchParams(window.location.search);
    if (sortValue) {
      params.set("sort_by", sortValue);
    } else {
      params.delete("sort_by");
    }

    this.updateSortButtonsUI(sortValue);

    // this.productCountElement のテキスト変更は fetch 後に行う

    const fetchUrl = `${window.location.pathname}?${params.toString()}`;

    try {
      const doc = await this.fetchAndParseHTML(fetchUrl);
      this.updateProductDisplay(doc);
      this.updateURL(params);
      this.updateCurrentSortDisplay();
    } catch (error) {
      console.error("ソート変更エラー:", error);
      if (this.productCountElement) this.productCountElement.textContent = "エラーが発生しました";
    } finally {
      this.showContents();
    }
  }

  async clearAllFilters() {
    this.hideContents();
    // if (this.productCountElement) this.productCountElement.textContent = "クリア中..."; // ボタンのローディングテキストで示す
    this.setButtonLoadingState(this.applyFiltersButton, this.applyFiltersButtonText, true, "クリア中...");

    const fetchUrl = window.location.pathname; // ベースURLで取得
    const params = new URLSearchParams(); // パラメータをクリア

    try {
      const doc = await this.fetchAndParseHTML(fetchUrl);
      this.updateProductDisplay(doc);

      this.filterForm.reset();
      // ケーススタディページでは価格フィルターは存在しないのでリセットしない
      if (!this.isCaseStudyPage) {
        const defaultPriceRadio = this.filterForm.querySelector('input[name="price_range"][value="all"]');
        if (defaultPriceRadio) defaultPriceRadio.checked = true;
      }

      // ソートをデフォルトに戻す
      let defaultSortBy = '{{ collection.default_sort_by | default: "" }}';
      defaultSortBy = defaultSortBy.startsWith("{{") ? "" : defaultSortBy; // Liquidが評価されなかった場合のフォールバック

      if (!defaultSortBy && this.sortByButtonsContainer && this.sortByButtonsContainer.firstElementChild) {
        defaultSortBy = this.sortByButtonsContainer.firstElementChild.dataset.sortBy;
      }

      this.updateSortButtonsUI(defaultSortBy);
      if (defaultSortBy && document.getElementById("sort-by-select")) {
        document.getElementById("sort-by-select").value = defaultSortBy;
      }

      this.updateURL(params); // URLからクエリパラメータを削除
      this.updateCurrentSortDisplay();

      const productCount = this.getProductCountFromDoc(doc);
      // ボタンのテキストと状態をここで最終的に設定
      this.setButtonLoadingState(this.applyFiltersButton, this.applyFiltersButtonText, false, "クリア中...", `条件を絞り込む (${productCount}件)`);
    } catch (error) {
      console.error("フィルタークリアエラー:", error);
      this.setButtonLoadingState(this.applyFiltersButton, this.applyFiltersButtonText, false, "クリア中...", "条件を絞り込む (エラー)");
    } finally {
      if (this.productsGridElement) {
        gsap.to(this.productsGridElement, {
          opacity: 1,
          duration: 0.15,
          delay: 0.3,
          ease: "linear",
        });
      }
      this.checkAndToggleApplyButtonVisibility();
      // finally ブロックでの updateProductCountOnButton 呼び出しは削除 (二重 fetch となるため)
      // 元々あった setButtonLoadingState も try/catch 内に移動し、最終的なテキストを反映するようにした
    }
  }

  // --- Initialization ---
  initializeFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    // タグフィルターの初期化
    const constraints = params.get("constraint");
    if (constraints) {
      constraints.split(",").forEach((tag) => {
        const checkbox = document.getElementById(`tag-${tag}`);
        if (checkbox) checkbox.checked = true;
      });
    }

    // 価格フィルターの初期化（ケーススタディページでは処理しない）
    if (!this.isCaseStudyPage) {
      const priceMinParam = params.get("filter.v.price.gte");
      const priceMaxParam = params.get("filter.v.price.lte");
      let priceRangeValue = "all";
      if (priceMinParam && !priceMaxParam && priceMinParam === "10001") priceRangeValue = "10001-";
      else if (!priceMinParam && priceMaxParam && priceMaxParam === "5000") priceRangeValue = "0-5000";
      else if (priceMinParam === "5001" && priceMaxParam === "10000") priceRangeValue = "5001-10000";
      else if (priceMinParam === "0" && priceMaxParam === "5000") priceRangeValue = "0-5000";
      // 他の価格帯があればここに追加

      const priceRadio = this.filterForm.querySelector(`input[name="price_range"][value="${priceRangeValue}"]`);
      if (priceRadio) priceRadio.checked = true;
    }

    // ソートの初期化
    const sortBy = params.get("sort_by");
    if (sortBy) {
      this.updateSortButtonsUI(sortBy);
    } else {
      // URLにsort_byがない場合、デフォルト（Shopify設定または最初のボタン）をアクティブにする
      let defaultSortBy = '{{ collection.default_sort_by | default: "" }}';
      defaultSortBy = defaultSortBy.startsWith("{{") ? "" : defaultSortBy; // Liquidが評価されなかった場合のフォールバック

      if (!defaultSortBy && this.sortByButtonsContainer && this.sortByButtonsContainer.firstElementChild) {
        defaultSortBy = this.sortByButtonsContainer.firstElementChild.dataset.sortBy;
      }
      if (defaultSortBy) {
        this.updateSortButtonsUI(defaultSortBy);
      }
    }
  }

  bindEventListeners() {
    this.filterForm.addEventListener("submit", (event) => {
      event.preventDefault();
      this.applyFilters();
    });

    const filterInputs = this.filterForm.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    filterInputs.forEach((input) => {
      input.addEventListener("change", this.handleFilterInputChange.bind(this));
    });

    if (this.sortByButtonsContainer) {
      this.sortByButtonsContainer.addEventListener("click", (event) => {
        if (event.target.classList.contains("sort-button")) {
          const sortValue = event.target.dataset.sortBy;
          if (sortValue && !event.target.classList.contains("active")) {
            // アクティブでない場合のみ実行
            window.Shopify.handleSortChange(sortValue); // これはグローバルShopifyオブジェクトの関数を呼ぶ
          }
        }
      });
    }
  }

  checkAndToggleApplyButtonVisibility() {
    if (!this.applyFiltersButton || !this.filterForm || !this.applyFiltersButtonText) return;

    const activeConstraintCheckboxes = this.filterForm.querySelectorAll('input[name="constraint"]:checked');
    const isAnyConstraintActive = activeConstraintCheckboxes.length > 0;

    let isPriceRangeDefault = true; // デフォルトは「すべて」扱い
    // ケーススタディページでは価格フィルターを考慮しない
    if (!this.isCaseStudyPage) {
      const priceRangeRadio = this.filterForm.querySelector('input[name="price_range"]:checked');
      if (priceRangeRadio) {
        isPriceRangeDefault = priceRangeRadio.value === "all";
      }
    }

    // ケーススタディページでは制約フィルターのみを考慮
    const shouldHideButton = this.isCaseStudyPage ? !isAnyConstraintActive : !isAnyConstraintActive && isPriceRangeDefault;

    if (shouldHideButton) {
      this.applyFiltersButton.classList.add("none");
      this.applyFiltersButtonText.textContent = "条件を指定してください";
    } else {
      this.applyFiltersButton.classList.remove("none");
      // フィルターがアクティブな場合、ボタンのテキストは updateProductCountOnButton や applyFilters で設定された
      // 件数表示（「条件を絞り込む (X件)」）になっているはずなので、ここでは変更しない。
      // もし明示的に再設定が必要な場合は、以下のような処理を検討するが、
      // updateProductCountOnButton の最後にも checkAndToggleApplyButtonVisibility が呼ばれるため、
      // 通常は不要で、むしろ updateProductCountOnButton の結果を上書きしてしまう可能性がある。
      // await this.updateProductCountOnButton(); // ここで呼ぶと二重処理や無限ループの可能性
    }
  }

  hideContents() {
    gsap.to(this.productsGridElement, {
      opacity: 0,
      duration: 0.15,
      ease: "linear",
    });
    this.filtersArea.classList.remove("is-open");
  }

  showContents() {
    gsap.to(this.productsGridElement, {
      opacity: 1,
      duration: 0.15,
      ease: "linear",
      delay: 0.3,
    });
  }
}

export default Filter;
